import React, { Fragment } from "react";
import "./DownloadButton.scss";
import { FC } from "react";
import { ReactSVG } from "react-svg";
import { EDownloadFileExtention, downloadApiCall } from "./DownloadApiCall";
import { useAuth0 } from "@auth0/auth0-react";

export enum EDownloadSource {
    DRAFT,
    TEMPLATE
}

interface IDownloadButtonProps {
    downloadId: string;
    filename: string;
    extension: EDownloadFileExtention;
    source: EDownloadSource;
}

const DownloadButton: FC<IDownloadButtonProps> = ({ downloadId, filename, extension, source }) => {
  const { getAccessTokenSilently } = useAuth0();

    const onClick = () => getAccessTokenSilently().then(token => {
        downloadApiCall(downloadId, filename, extension, source, token);
      });
      
    const getIcon = () => {
        switch(extension) {
            case EDownloadFileExtention.WORD:
                return require("../../../../Assets/icons/file-doc.svg").default;
            case EDownloadFileExtention.PDF:
                return require("../../../../Assets/icons/file-pdf.svg").default;
        }
    }

    const getText = () => {
        switch(extension) {
            case EDownloadFileExtention.WORD:
                return 'Word'
            case EDownloadFileExtention.PDF:
                return 'PDF'
        }
    }

    return (
        <Fragment>
            {<div className="download-button" onClick={onClick}><ReactSVG src={getIcon()}/>{getText()}</div>}
        </Fragment>
    );
}

export default DownloadButton;